<div class="app" [ngClass]="{'theme-alternate':isDarkMode|async}">
  <div class="app-ib">
    <app-layout [config]="layoutConfig" [isAuthenticated]='isAuthenticated' [user]='user'>
      <div class="page-content">
        <!--  We inject all page here -->
      </div>
    </app-layout>
  </div>
</div>
